var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"mt-5 px-0 mx-6 border-radius-xl toolbar-content-padding-y-none",class:_vm.navbarFixed
      ? 'position-sticky blur shadow-blur top-1 z-index-sticky py-2'
      : '',attrs:{"color":_vm.background,"height":"auto","flat":""}},[_c('v-row',{staticClass:"py-1"},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","sm":"6"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }